import { NamedChartComponent } from '@frontend/chart/components';
import { FormattedMessage } from 'react-intl';

import { StatisticsCard } from '../shared';
import { useLast60DaysPudoTimerDurationMetricChart } from './use-last-60-days-pudo-timer-duration-metric-chart';

export interface Last60DaysPudoTimerDurationMetricChartCardProps {
    accountId: string;
    title: React.ReactNode;
    Chart: NamedChartComponent;
}

export const Last60DaysPudoTimerDurationMetricChartCard = ({ accountId, title, Chart }: Last60DaysPudoTimerDurationMetricChartCardProps) => {
    const { data, isLoading, hasData } = useLast60DaysPudoTimerDurationMetricChart(accountId, Chart.definition);

    return (
        <StatisticsCard
            chartKey={Chart.definition.key}
            title={title}
            compact
            subtitle={
                <FormattedMessage
                    id='platform.statistics.pudo.last-60-days-pudo-timer-duration-metric-chart-card.compared-to-last-month'
                    description='Subtitle on PuDo dashboard cards comparing average drop-off or pick-up time for the last 30 days against the previous month'
                    defaultMessage='Compared to last month'
                />
            }
            isLoading={isLoading}
            hasData={hasData}>
            {data && (
                <div className='mt-auto w-full'>
                    <Chart data={data} />
                </div>
            )}
        </StatisticsCard>
    );
};
